import { render } from "./audioVideoControlBar.vue?vue&type=template&id=70a38c14&scoped=true&ts=true"
import script from "./audioVideoControlBar.vue?vue&type=script&lang=ts"
export * from "./audioVideoControlBar.vue?vue&type=script&lang=ts"

import "./audioVideoControlBar.vue?vue&type=style&index=0&id=70a38c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a38c14"]])

export default __exports__